import { superagent } from '../../shared/superagent/superagent';

import singletons from '../../shared/singletons'

import { Observable } from 'rxjs'

class DistrictsApi {
  periods(district_id = null, date = null) {
    let prms = {}
    if(district_id) {
      prms['district_id'] = district_id
    }

    if(date) {
      prms['date'] = date
    }

    return Observable.create((obs)=> {
      singletons['loading'].start()
      superagent.post("/api/avaliable_periods")
        .send(prms)
        .end((err, resp)=> {
          const data = resp.body
          singletons['loading'].stop()
          obs.next(data)
          obs.complete()
        })
    })
  }

}

const districtsApi = new DistrictsApi()

export { districtsApi };



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/districts_api.js